// setPostDraftData.js
'use strict';
import { uniq } from 'lodash';

import {
  MERGE_OPERATION_DATA,
  SET_OPERATION_DATA,
  REMOVE_OPERATION_DATA,
} from '../ActionTypes.js';
import {
  FLIX_TITLE_CHARS_MAX,
  SCHEDULE_POST_DEFAULT_DURATION_SEC,
} from '../RemoteConfigKeys.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { PostDraftField } from '../resource/uploadConstants.js';

/**
 * Set post draft data
 * @kind action
 * @param {string} {key} - update key.
 * @param {object} {payload} - payload.
 * @return {Promise} Action promise.
 */
const setPostDraftData =
  ({ key, payload = {} } = {}) =>
  async (dispatch, getState) => {
    const { value, error } = payload;
    if (error) {
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['postDraft', key, 'error'],
          data: {
            i18nKey: error?.i18nKey,
            i18nOption: error?.i18nOption,
          },
        },
      });
    }
    if (PostDraftField.TITLE === key) {
      const maximum = getRemoteConfigData(getState(), FLIX_TITLE_CHARS_MAX);
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['postDraft', key],
          data: {
            value: value?.replace(/[\b]/g, ' ')?.slice(0, maximum),
          },
        },
      });
    }
    if (PostDraftField.IS_SCHEDULE_ENABLED === key) {
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['postDraft', key],
          data: {
            value,
          },
        },
      });
      if (value) {
        const scheduledSecondsMin = getRemoteConfigData(
          getState(),
          SCHEDULE_POST_DEFAULT_DURATION_SEC
        );
        return dispatch({
          type: MERGE_OPERATION_DATA,
          payload: {
            selectPath: ['postDraft', PostDraftField.SCHEDULED_AT_UNIX],
            data: {
              // The default schedule time is now(seconds, precision to minutes) + min scheduled seconds
              value:
                Math.floor(Date.now() / 1000 / 60) * 60 + scheduledSecondsMin,
            },
          },
        });
      }
      return dispatch({
        type: REMOVE_OPERATION_DATA,
        payload: {
          selectPath: ['postDraft', PostDraftField.SCHEDULED_AT_UNIX],
        },
      });
    }
    if (PostDraftField.CATEGORIES === key) {
      return dispatch({
        type: SET_OPERATION_DATA,
        payload: {
          selectPath: ['postDraft', key],
          data: { value: uniq(value || []) },
        },
      });
    }
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['postDraft', key],
        data: {
          value,
        },
      },
    });
  };

export default setPostDraftData;
